import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import API_BASE from "../config/api";

export default function UpgradeListing() {
    const navigate = useNavigate();
    const [params] = useSearchParams();
    const listinguid = params.get("listinguid");

    // Logged-in user
    const localUser = JSON.parse(localStorage.getItem("user"));
    const personaluid = localUser?.personaluid;

    const [selected, setSelected] = useState([]);
    const [promotionDays, setPromotionDays] = useState(0);
    const [loading, setLoading] = useState(false);

    // Upgrade options
    const options = [
        { id: 1, title: "Verified Badge", icon: "✔️", price: 49 },
        { id: 2, title: "Featured Listing", icon: "🔥", price: 99 },
        { id: 3, title: "Priority Listing", icon: "⬆️", price: 149 }
    ];

    const toggleSelect = (id) => {
        setSelected((prev) =>
            prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
        );
    };

    // Total price calculation
    const finalAmount = selected.reduce((sum, id) => {
        const opt = options.find((o) => o.id === id);
        return sum + opt.price;
    }, promotionDays * 20);

    // Submit upgrade
    const handleProceed = async () => {
        if (selected.length === 0 && promotionDays === 0) {
            alert("Select at least one upgrade option.");
            return;
        }

        setLoading(true);

        const localUser = JSON.parse(localStorage.getItem("user") || "{}");
        const user_id = localUser?.personaluid || null;

        try {
            const res = await fetch(`${API_BASE}/api/generate_fonepay_payment.php`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    listinguid,
                    selected_plans: selected,
                    promotion_days: promotionDays,
                    total_amount: finalAmount,
                    user_id
                })
            });
            const data = await res.json();
            setLoading(false);

            if (data.success && data.payment_url) {
                // redirect user to Fonepay (sandbox)
                window.location.href = data.payment_url;
            } else {
                alert(data.message || "Payment initialization failed");
            }
        } catch (err) {
            console.error(err);
            setLoading(false);
            alert("Network error");
        }
    };

    return (
        <div className="container py-4" style={{ maxWidth: "720px" }}>


            <h3 className="fw-bold text-center mb-4">Upgrade Your Listing</h3>

            <div className="list-group shadow-sm rounded-3">
                {options.map((opt) => (
                    <div
                        key={opt.id}
                        className={`list-group-item list-group-item-action d-flex justify-content-between align-items-center py-3 
                            ${selected.includes(opt.id) ? "active-plan" : ""}`}
                        onClick={() => toggleSelect(opt.id)}
                        style={{ cursor: "pointer" }}
                    >
                        <div className="d-flex align-items-center">
                            <span className="fs-3 me-3">{opt.icon}</span>
                            <div>
                                <h6 className="m-0 fw-bold">{opt.title}</h6>
                                <small className="text-muted">₹ {opt.price}</small>
                            </div>
                        </div>
                        <input type="checkbox" checked={selected.includes(opt.id)} readOnly />
                    </div>
                ))}

                {/* Promotion Input */}
                <div className="list-group-item py-3">
                    <h6 className="fw-bold mb-1">Limited-Time Promotion ⏱️</h6>
                    <small className="text-muted">₹ 20 per day</small>

                    <input
                        type="number"
                        className="form-control mt-2"
                        min="0"
                        max="30"
                        value={promotionDays}
                        onChange={(e) => setPromotionDays(Number(e.target.value))}
                        placeholder="Enter days (0 - 30)"
                    />
                </div>
            </div>

            {/* TOTAL CARD */}
            <div className="card shadow-sm mt-4">
                <div className="card-body d-flex justify-content-between align-items-center">
                    <h5 className="m-0 fw-bold">Total Amount:</h5>
                    <h4 className="m-0 text-primary">₹ {finalAmount}</h4>
                </div>
            </div>

            {/* ACTION BUTTONS IN ONE ROW */}
            <div className="d-flex justify-content-between align-items-center mt-4 gap-3">

                <button
                    className="btn btn-outline-warning w-50 py-2"
                    onClick={() => navigate(`/admin?userid=${personaluid}`)}
                >
                    ← Back
                </button>

                <button
                    className="btn btn-primary w-50 py-2"
                    onClick={handleProceed}
                    disabled={loading}
                >
                    {loading ? "Processing..." : "Proceed to Payment"}
                </button>

            </div>


            <style>{`
                .active-plan {
                    background: #e9f5ff;
                    border-left: 4px solid #007bff;
                }
                .active-plan h6 {
                    color: #007bff;
                }
            `}</style>
        </div>
    );
}
